/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Fallback_DescriptionInputs */

const cs_automation_template_fallback_description = /** @type {(inputs: Automation_Template_Fallback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravený startér — detaily nastavíte po vytvoření.`)
};

const en_automation_template_fallback_description = /** @type {(inputs: Automation_Template_Fallback_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter workflow — configure details after creating.`)
};

/**
* | output |
* | --- |
* | "Starter workflow — configure details after creating." |
*
* @param {Automation_Template_Fallback_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_fallback_description = /** @type {((inputs?: Automation_Template_Fallback_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Fallback_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_fallback_description(inputs)
	return cs_automation_template_fallback_description(inputs)
});